import { useEffect, useState } from 'react'

import { StylePanelProps } from '@/lib/stylePanel'

export interface ResponsivePaddingProps {
  paddingBottom?: string
  paddingTop?: string
  paddingLeft?: string
  paddingRight?: string
}

const useResponsivePadding = (initialPadding: StylePanelProps['padding']) => {
  const [paddingStyles, setPaddingStyles] = useState({})
  const [padding, setPadding] = useState(initialPadding)

  useEffect(() => {
    if (initialPadding?.default) {
      setPadding({
        unit: 'rem',
        default: true,
        desktop: { top: 2, right: 0, bottom: 2, left: 0 },
        tablet: { top: 1.5, right: 0.5, bottom: 1.5, left: 0.5 },
        mobile: { top: 1, right: 0.5, bottom: 1, left: 0.5 },
      })
    } else {
      setPadding(initialPadding)
    }
  }, [initialPadding])

  useEffect(() => {
    const updatePaddingStyles = () => {
      const width = window.innerWidth
      let paddingStyle
      if (width <= 480) {
        paddingStyle = padding?.mobile || { top: 0, right: 0, bottom: 0, left: 0 }
      } else if (width <= 768) {
        paddingStyle = padding?.tablet || { top: 0, right: 0, bottom: 0, left: 0 }
      } else {
        paddingStyle = padding?.desktop || { top: 0, right: 0, bottom: 0, left: 0 }
      }

      setPaddingStyles({
        paddingTop: `${paddingStyle.top}${padding?.unit || 'px'}`,
        paddingRight: `${paddingStyle.right}${padding?.unit || 'px'}`,
        paddingBottom: `${paddingStyle.bottom}${padding?.unit || 'px'}`,
        paddingLeft: `${paddingStyle.left}${padding?.unit || 'px'}`,
      })
    }

    updatePaddingStyles()
    window.addEventListener('resize', updatePaddingStyles)
    return () => {
      window.removeEventListener('resize', updatePaddingStyles)
    }
  }, [padding])

  return paddingStyles as ResponsivePaddingProps
}

export default useResponsivePadding
